/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Artic
 * The Artic API documentation
 * OpenAPI spec version: 1.0
 */
import {
  useMutation
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query';

import type {
  TagMigrationEnqueuedResponseDto
} from '.././schemas';

import { customFetch } from '../../custom-fetch';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Enqueues a background job that copies legacy Tag values into Custom Columns for every applicable work order of the partner. Push-only: values are set/overwritten from the tag but never cleared when a tag is removed. Mappings are hardcoded per partner_key, so this is a no-op for an unmapped partner — the response reports `enqueued: false` with `reason: "no_mapping_for_partner"` rather than queueing work that would do nothing. Per-mapping `column_ready` flags whether the target custom column exists and is the expected type.
 * @summary Backfill custom columns from legacy work-order tags for a partner
 */
export type tagMigrationControllerRunResponse202 = {
  data: TagMigrationEnqueuedResponseDto
  status: 202
}

export type tagMigrationControllerRunResponse401 = {
  data: void
  status: 401
}

export type tagMigrationControllerRunResponse403 = {
  data: void
  status: 403
}
    
export type tagMigrationControllerRunResponseSuccess = (tagMigrationControllerRunResponse202) & {
  headers: Headers;
};
export type tagMigrationControllerRunResponseError = (tagMigrationControllerRunResponse401 | tagMigrationControllerRunResponse403) & {
  headers: Headers;
};

export type tagMigrationControllerRunResponse = (tagMigrationControllerRunResponseSuccess | tagMigrationControllerRunResponseError)

export const getTagMigrationControllerRunUrl = (partnerId: string,) => {


  

  return `/partners/${partnerId}/tag-migration/run`
}

export const tagMigrationControllerRun = async (partnerId: string, options?: RequestInit): Promise<tagMigrationControllerRunResponse> => {
  
  return customFetch<tagMigrationControllerRunResponse>(getTagMigrationControllerRunUrl(partnerId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getTagMigrationControllerRunMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tagMigrationControllerRun>>, TError,{partnerId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof tagMigrationControllerRun>>, TError,{partnerId: string}, TContext> => {

const mutationKey = ['tagMigrationControllerRun'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof tagMigrationControllerRun>>, {partnerId: string}> = (props) => {
          const {partnerId} = props ?? {};

          return  tagMigrationControllerRun(partnerId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TagMigrationControllerRunMutationResult = NonNullable<Awaited<ReturnType<typeof tagMigrationControllerRun>>>
    
    export type TagMigrationControllerRunMutationError = void

    /**
 * @summary Backfill custom columns from legacy work-order tags for a partner
 */
export const useTagMigrationControllerRun = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tagMigrationControllerRun>>, TError,{partnerId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof tagMigrationControllerRun>>,
        TError,
        {partnerId: string},
        TContext
      > => {

      const mutationOptions = getTagMigrationControllerRunMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    